module.exports = __webpack_public_path__ + "img/bg_content.691c458f.png";